import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import RingLoader from "react-spinners/ScaleLoader";

//componentes
import "./nomina.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

function ReporteDecimoE(props) {
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [paso, setpaso] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [anio, setanio] = React.useState([]);
  const [mes, setmes] = React.useState([]);
  const [opcionR, setopcionR] = React.useState([]);
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");
  const [trimestre, settrimestre] = React.useState(0);
  const [anopagar, setanopagar] = React.useState("");
  const [mesapagar, setmesapagar] = React.useState("");
  const [sede, setsede] = React.useState("");
  const [sedes, setSedes] = React.useState([]);
  const [datosNoReporte, setdatosNoReporte] = React.useState([]);
  const datosNoReporteRef = React.useRef([]);

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    if (index === "trimestre") {
      settrimestre(e.target.value);
    }
    if (index === "anopagar") {
      setanopagar(e.target.value);
    }
    if (index === "mesapagar") {
      setmesapagar(e.target.value);
    }
    if (index === "opcionR") {
      setopcionR(e.target.value);
    }
    if (index === "sede") {
      setsede(e.target.value);
    }
  };

  const generarPrenomina = () => {
    setloading(true);

    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    data.append("boton", "calcularPrenomina");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/prenomina.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        //let ximedicos = res.data.variable2;
        if (res.data.variable1) {
          if (res.data.variable2===1 && res.data.variable3===res.data.variable4) {
            setmensajealerta(true);
            settituloM("Menu Pre-Nomina.");
            setcuerpoM("La quincena esta CERRADA, no afectara ningún cambio.");
          }
          if (res.data.variable2===1 && res.data.variable3!==res.data.variable4) {
            setmensajealerta(true);
            settituloM("Menu Pre-Nomina.");
            setcuerpoM("La quincena esta CERRADA, y existe una diferencia de registros entre lo guardado y lo consultado, y no se registrara ningún cambio.");

          }

          setpaso(true);
          const raw = res.data.variable5;
          const lista = Array.isArray(raw)
            ? raw
            : raw && typeof raw === "object"
            ? Object.values(raw)
            : [];
          datosNoReporteRef.current = lista;
          setdatosNoReporte(lista);
          setloading(false);
        } else {
          setpaso(false);
        }
      });
  };

  const otraConsulta = () => {
    setpaso(false);
    datosNoReporteRef.current = [];
    setdatosNoReporte([]);
  };

  const handleClose = () => {
    setmensajealerta(false);
  };

  const cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/fecha.php";
    axios.post(xurl).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        //let xdia = res.data.variable3;
        //dia: xdia,
        setmes(xmes);
        setanio(xanio);
      }
    });
  };

  const buscarTipoReporte = () => {
    if (opcionR === "1") especialistaTodo();
    if (opcionR === "2") especialistaTotales();
    if (opcionR === "3") consultasSinReporte();
  };

  const consultasSinReporte = () => {
    const fromState = Array.isArray(datosNoReporte)
      ? datosNoReporte
      : datosNoReporte && typeof datosNoReporte === "object"
      ? Object.values(datosNoReporte)
      : [];
    const fromRef = Array.isArray(datosNoReporteRef.current)
      ? datosNoReporteRef.current
      : Object.values(datosNoReporteRef.current || {});
    const lista = fromState.length > 0 ? fromState : fromRef;
    if (lista.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Pre-Nomina.");
      setcuerpoM("No hay datos de consultas sin reporte para generar el PDF.");
      return;
    }
    let data = new FormData();
    data.append("datos", JSON.stringify(lista));
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/citaSinReporte.php",
      responseType: "arraybuffer",
      data: data,
    })
      .then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Menu Pre-Nomina.");
        setcuerpoM("Error al generar el reporte PDF de consultas sin reporte.");
      });
  };
  const especialistaTotales = () => {
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/prenominaTotales.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };
  const especialistaTodo = () => {
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/prenomina.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  React.useEffect(() => {
    //console.log(props.cedulaempleado);
    cargarFechas();
    fetchSedes().then(setSedes);
  }, []);

  return (
    <div className="principal-pago row">
      <div className="contenedor-cxc col-12">
        <div className="titulo-cxc ">
          <p>GENERAR PRE-NOMINA ESPECIALISTAS. </p>
        </div>
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {loading && (
          <div className="cont-spinner row">
            <div className="spinner col-6">
              <RingLoader
                clasName="spinner"
                sizeUnit={"px"}
                size={160}
                width={19}
                radius={20}
                height={160}
                color={"#48e120"}
                loading={loading}
              />
            </div>
          </div>
        )}

        <div className="cont-listmedi row">
          <div className="cont-personal col-2">
            <label className="titulo-salario2">Sede.</label>

            <select
              id="sede"
              name="sede"
              value={sede}
              onChange={onChange}
            >
              <option>-Seleccione Sucursal-</option>
              {sedes.map((item) => (
                <option key={item.variable1} value={String(item.variable1)}>
                  {item.variable2}
                </option>
              ))}
            </select>
          </div>
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Quincena a consultar.
              <select
                id="trimestre"
                name="trimestre"
                value={typeof trimestre !== "undefined" ? trimestre : ""}
                onChange={onChange}
              >
                <option value="0">Seleccione Quincena</option>
                <option value="1">Primera Quincena.</option>
                <option value="2">Segunda Quincena.</option>
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Mes a Pagar.
              <select
                id="mesapagar"
                name="mesapagar"
                value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                onChange={onChange}
              >
                <option value="0">Mes a Pagar</option>
                {mes.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable2}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Año a Pagar.
              <select
                id="anopagar"
                name="anopagar"
                value={typeof anopagar !== "undefined" ? anopagar : ""}
                onChange={onChange}
              >
                <option value="0">Año a Pagar</option>
                {anio.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable1}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
        </div>
        {}
        {paso === true && (
          <div className="cont-listmedi row">
            <div className="cont-personal col-4">
              <label className="titulo-salario2">
                Seleccione un Reporte.
                <select
                  id="opcionR"
                  name="opcionR"
                  value={typeof opcionR !== "undefined" ? opcionR : ""}
                  onChange={onChange}
                >
                  <option value="0"></option>
                  <option value="1">
                    especialistas por estudios Cobrados.
                  </option>
                  <option value="2">especialistas Totales.</option>
                  <option value="3">Terapias sin Reporte</option>
                </select>
              </label>
            </div>
            <div className="cont-personal col-4">
              <button className="botonN" onClick={buscarTipoReporte}>
                Imprimir
              </button>
            </div>
          </div>
        )}

        <div className="cont-personal col-12">
          {paso === false && (
            <button className="botonN" onClick={generarPrenomina}>
              Generar Pre-Nomina
            </button>
          )}
          {paso === true && (
            <button className="botonN" onClick={otraConsulta}>
              Otra Consulta
            </button>
          )}
          <button className="boton" onClick={props.personalClose}>
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(ReporteDecimoE);
